import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

interface DashboardCardProps {
  title: string;
  value: number;
  icon: React.ReactNode;
  stats: Array<{
    label: string;
    value: number;
  }>;
  buttonText: string;
  onButtonClick: () => void;
  className?: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  value,
  icon,
  stats,
  buttonText,
  onButtonClick,
  className = "",
}) => {
  return (
    <div className={`bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 flex flex-col ${className}`}>
      <div className="flex items-center justify-between mb-6">
        <div className="bg-gray-200 p-3 rounded-lg">
          {icon}
        </div>
        <div className="text-right">
          <p className="text-gray-500 text-sm font-medium">
            {title}
          </p>
          <h2 className="text-3xl font-bold text-gray-800">
            {value}
          </h2>
        </div>
      </div>

      <div className="border-t border-gray-100 pt-4 space-y-3 mb-4 flex-grow">
        {stats.map((stat, index) => (
          <div key={index} className="flex justify-between items-center">
            <span className="text-gray-600 text-sm flex items-center gap-2">
              {stat.label}
            </span>
            <span className="text-lg font-semibold text-gray-800">
              {stat.value}
            </span>
          </div>
        ))}
      </div>

      <button
        onClick={onButtonClick}
        className="w-full mt-auto bg-primary hover:shadow-xl text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
      >
        {buttonText}
        <FaArrowRight className="text-sm" />
      </button>
    </div>
  );
};

export default DashboardCard;
